import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { TasksService } from '@/services/tasks.service'

const getStatus = (error: unknown) =>
	error instanceof AxiosError ? error.response?.status : undefined

export const useHome = () => {
	const { data: listeners, isLoading: isListenersLoading } = useQuery({
		queryKey: ['getListeners'],
		select: response => response.tasks,
		queryFn: () => TasksService.getListeners(),
		retry: (failureCount, error) => {
			const status = getStatus(error)

			if (status === 403) return false

			return failureCount < 3
		},
		retryOnMount: false,
		cacheTime: Infinity,
		refetchInterval: (_data, query) => {
			const status = getStatus(query.state.error)

			return status === 403 ? false : 15000
		}
	})

	const { data: tasks, isLoading: isTasksLoading } = useQuery({
		queryKey: ['getTasks'],
		queryFn: () => TasksService.getTasks(),
		refetchInterval: 30000
	})

	const { data: languages, isLoading: isLanguagesLoading } = useQuery({
		queryKey: ['getLanguages'],
		queryFn: () => TasksService.getLanguages()
	})

	return {
		listeners,
		isListenersLoading,
		tasks,
		languages,
		isTasksLoading,
		isLanguagesLoading
	}
}
